import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'sp-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  public loading: boolean = false;
  public type: any;
  data: any;
  message: any;
  note: string = '';
  updating: boolean = false;
  completed: boolean = false;
  actionPending: boolean = false;
  constructor(
    private cd: ChangeDetectorRef
  ) {
    // Office.context.ui.messageParent('send');
    // Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived,async (arg: any) => {
    //   this.data=JSON.parse(arg.message)
    //   })
    this.loading = true;
    Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, async (arg: any) => {
      const item=JSON.parse(arg.message);
      console.log(item);
      this.data = !!item ? item : null;
      this.message = !!item ? item?.message : 'The content of active worksheet will be deleted. Do you want to continue?';
      this.type = !!item ? item?.type : 'warning';
      this.note = item?.note || '';
      this.updating = !!item?.statusOnly;
      this.completed = !!item?.completed;
      this.loading = false;
      this.cd.detectChanges();
    }, () => Office.context.ui.messageParent('send'));
  }
  onDismiss(): void {
    if (this.actionPending) return;
    this.actionPending = true;
    this.cd.detectChanges();
    Office.context.ui.messageParent('close');
  }
  onConfirm(): void {
    if (this.actionPending) return;
    this.actionPending = true;
    this.message = 'Preparing worksheet update...';
    this.cd.detectChanges();
    Office.context.ui.messageParent('continue');
  }
}

export interface ConfirmDialogData {
  title: string;
  message: string;
  icon?: string;
  yes?: string;
  no?: string;
  maxWidth?: number;
  minWidth?: number;
}
